﻿import { AdpVoucherBatchType } from '../enums/index';

export interface IAdpBatchInfo {
    id: number;
    batchTypeId: AdpVoucherBatchType;
    batchType: string,
    createdDateTime: string;
    count: number;
}